import styled from 'styled-components'

const StyledCartItem = styled.li`
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 4px;

  .cart-item {
    grid-gap: 10px;
    justify-content: space-between;
    display: flex;
    align-items: center;
  
    .btn {
      flex-shrink: 0;
    }
  
    .item-details {
      display: grid;
      grid-template-columns: 75px minmax(0, 1fr);
      grid-gap: 1rem;
      align-content: start;
  
      .item-preview {
        height: 50px;
        position: relative;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${({ theme }) => theme.colors.gray[100]};
  
        svg {
          height: 24px;
          color: ${({ theme }) => theme.colors.gray[300]};
        }
  
        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 3px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
  
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 3px;
          width: 100%;
          height: 100%;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
  
      .item-info {
        display: grid;
        align-self: center;
        grid-gap: 6px;
  
        .item-title {
          font-weight: bold;
          color: ${({ theme }) => theme.colors.gray[700]};
          word-break: break-all;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          display: -webkit-box;
          line-height: 19px;
        }
  
        .item-description {
          font-weight: 600;
          font-size: 14px;
          color: ${({ theme }) => theme.colors.gray[500]};
        }
      }
    }
  
    .item-actions {
      text-align: right;
      margin-left: 1rem;
      display: grid;
      justify-items: end;
  
      b {
        color: ${({ theme }) => theme.colors.gray[600]};
      }
  
      .slashed-price {
        margin-left: 8px;
        color: ${({ theme }) => theme.colors.gray[400]};
        text-decoration-line: line-through;
      }
  
      .remove-item-btn {
        color: ${({ theme }) => theme.colors.green[500]};
        font-size: 14px;
        text-align: right;
        padding: 0;
        height: unset;
        margin-top: 4px;
  
        &:hover {
          text-decoration: underline;
        }
      }
    }
  
    .view-btn {
      flex-shrink: 0;
      margin-left: 1rem;
    }
  }

  .payment-plan-select {
    margin-top: 1rem;
    align-self: flex-end;
  }
`

export default StyledCartItem
